require("./locationDetailsTransactions.less");

class LocationDetailsTransactionsController {
    transactions;
    pageInfo = {pageSize: 100, pageNo: 0};

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
    };

    tableDefinition = {
        settings: {
            promise: null,
            totalElements: null,
            hideToolbar: true,
            onPaginate: (page, limit) => this.changePage(page, limit),
            initialPageSize: 11},
        columns:[
            {title:'Tidspunkt', name: 'createdTime', type:'date', dateFormat: 'dd.MM.yyyy - HH:mm', noOrderBy: true},
            {title:'Vare', name:'itemId', noOrderBy: true},
            {title:'Bruker', name:'createdBy', noOrderBy: true},
            {title:'Type', name:'type', noOrderBy: true},
            {title:'ID', name:'orderNo', noOrderBy: true},
            {title:'Antall', name:'quantity', type:'number', noOrderBy: true}
        ]
    };

    constructor(private toastService, private Locations, private $stateParams){
    }

    $onInit() {
        this.getLocationTransactions();
    }

    getLocationTransactions() {
        this.tableDefinition.settings.promise = this.Locations.getLocationTransactions({locationId: this.$stateParams.locationId, pageSize: this.pageInfo.pageSize, pageNo: this.pageInfo.pageNo}).$promise.then((results) => {
            this.transactions = results.content;
            this.tableDefinition.settings.totalElements = results.totalElements;
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    changePage(page, limit) {
        this.pageInfo.pageSize = limit;
        this.pageInfo.pageNo = page - 1;
        this.getLocationTransactions();
    }
}

class LocationDetailsTransactionsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcLocationDetailsTransactionsController";
    public template: any = require('./locationDetailsTransactions.html');
}

rkcApp.controller("rkcLocationDetailsTransactionsController", ['toastService', 'Locations', '$stateParams', function(toastService, Locations, $stateParams){
    return new LocationDetailsTransactionsController(toastService, Locations, $stateParams);
}])
    .component("rkcLocationDetailsTransactions", new LocationDetailsTransactionsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/locations/locationDetails/locationDetailsTransactions/locationDetailsTransactions.ts
 **/